<itl-selection
  [title]="node.title"
  [(ngModel)]="value"
  [values]="selectionItems"
  [compareFn]="compareFn"
  [description]="node.description"
  [required]="node.mandatory"
  [icon]="node.globalType ? (node.globalType | globalTypeIcon) : null"
  *ngIf="!allowMultiple"
  showSearch="true"
>
</itl-selection>
<itl-checkbox-select
  [(ngModel)]="value"
  [title]="node.title"
  [headerText]="node.title"
  [selectionItems]="selectionItems"
  [compareFn]="compareFn"
  [description]="node.description"
  [required]="node.mandatory"
  [icon]="node.globalType ? (node.globalType | globalTypeIcon) : null"
  *ngIf="allowMultiple"
  showSearch="true"
></itl-checkbox-select>
